var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNominneeEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05706 10.8062C1.9413 10.6229 1.88342 10.5313 1.85102 10.3899C1.82668 10.2837 1.82668 10.1163 1.85102 10.0101C1.88342 9.86874 1.9413 9.7771 2.05706 9.5938C3.01365 8.07912 5.86104 4.25 10.2003 4.25C14.5396 4.25 17.3869 8.07912 18.3435 9.5938C18.4593 9.7771 18.5172 9.86874 18.5496 10.0101C18.5739 10.1163 18.5739 10.2837 18.5496 10.3899C18.5172 10.5313 18.4593 10.6229 18.3435 10.8062C17.3869 12.3209 14.5396 16.15 10.2003 16.15C5.86104 16.15 3.01365 12.3209 2.05706 10.8062Z",
    stroke: "#142C4B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2003 12.75C11.6086 12.75 12.7503 11.6083 12.7503 10.2C12.7503 8.79168 11.6086 7.65 10.2003 7.65C8.79197 7.65 7.6503 8.79168 7.6503 10.2C7.6503 11.6083 8.79197 12.75 10.2003 12.75Z",
    stroke: "#142C4B",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNominneeEye);
export default __webpack_public_path__ + "static/media/nominnee-eye.d1b26c76661c8bfc52f6049bcf0cc70c.svg";
export { ForwardRef as ReactComponent };